@if (config().isLoading) {
  @if (config().type === 'small') {
    <div class="mini-spinner-wrapper">
      <div class="mini-spinner"></div>
    </div>
  } @else if (config().type === 'full') {
    <div class="loader-wrapper">
      <div class="loader">
        <div class="logo">
          <img src="assets/images/smarttos-logo-small.svg" alt="SmartTOS">
        </div>
        <div class="progress-container">
          <div class="indeterminate-progress">
            <div class="progress-bar">
              <div class="progress-bar-fill"></div>
            </div>
          </div>
        </div>
        <div class="spinner-text">{{ config().message }}</div>
        @if (config().dismissible) {
          <button class="dismiss-btn" (click)="dismiss()">Dismiss</button>
        }
      </div>
    </div>
  }
}
